<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayPositionStrategy]="positionStrategy"
  [cdkConnectedOverlayOpen]="true"
  [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-dark-backdrop"
  cdkConnectedOverlayPanelClass="planning-path-panel"
>
  <div class="popup" data-cy="navigation-planning-path">
    <div class="content">
      <div class="top">
        <cue-icon [icon]="ICONS.cueNavigationCircle" size="normal" class="!h-[35px] !w-[35px] rotate icon" />
        <h3 class="title">
          {{ translation.navigation.calculatingPath | transloco }}
          <div class="loader"></div>
        </h3>
      </div>
    </div>
  </div>
</ng-template>
